export const DAP_API = import.meta.env.VITE_PIEDAP_DAP_API_BASE_URL;
export const GRCNEST_BASE_URL = import.meta.env.VITE_PIEDAP_GRCNEST_API_BASE_URL;
export const TALENAISE_BASE_URL = import.meta.env.VITE_PIEDAP_TALENAISE_API_BASE_URL;
export const EVALTIQ_BASE_URL = import.meta.env.VITE_PIEDAP_EVALTIQ_API_BASE_URL;
export const IAM_API = import.meta.env.VITE_PIEDAP_IAM_API_BASE_URL;
